import { useNavigate } from "react-router-dom"
import { useAppDispatch, useAppSelector } from "../../../lib/redux/hooks"
import { EditIcon } from "../../../ui/icons/edit"
import { useEffect } from "react"
import { formatterDate, getNotificationLabelByValue, } from "../../../utils"
import { addDays } from "date-fns"

export function MonitoringM24EmessiList() {
    const dispatch = useAppDispatch()
    const navigate = useNavigate()
    const m24Open = useAppSelector(state => state.m24Open)

    return (
        <div className="mt-6">
            <table id="users-table" className="w-[100%]">
                <thead className="h-[52px] uppercase">
                    <tr>
                        <th style={{ borderTopLeftRadius: '8px' }}>SOT</th>
                        <th>Regione</th>
                        <th>Cod. Op</th>
                        <th>Ciente</th>
                        <th>Data</th>
                        <th>Stato</th>
                        <th>M005 Numero</th>
                        <th>M005 Data Inizio</th>
                        <th>M005 Data Scadenza</th>
                        <th>M006 Numero</th>
                        <th>M006 Data Inizio</th>
                        <th>M006 Data Fine</th>
                        <th>M029 numero</th>
                        <th>Validità M029</th>
                        <th>M029 numero</th>
                        <th>Tipo Norma</th>
                        <th style={{ borderTopRightRadius: '8px' }}>Tipologia</th>
                    </tr>
                </thead>
                <tbody>
                    {
                        m24Open.GetAllM24OpenResponse?.map((fs, index) => (
                            <tr
                                key={index}
                                style={{
                                    color: '#4D797F',
                                    background: index % 2 === 0 ? '#F2F7F7' : '#FFFFFF'
                                }}
                            >
                                <td>{fs.customerRegion}</td>
                                <td>{fs.customerHeadQuarters}</td>
                                <td>{fs.customerClientCode}</td>
                                <td>{fs.customerCompanyName}</td>
                                <td>{formatterDate(fs.startingDate)}</td>
                                <td>{formatterDate(fs.endingDate)}</td>
                                <td></td>
                                <td>{formatterDate(addDays(new Date(fs.startingDate), 90))}</td>
                                <td>-</td>
                                <td>-</td>
                                <td>-</td>
                                <td>-</td>
                                <td>-</td>
                                <td>-</td>
                                <td>-</td>
                                <td>-</td>
                                <td>-</td>
                            </tr>
                        ))}

                </tbody>
            </table>
        </div>
    )
}